import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPytorchLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.3685 9.31379L17.8584 7.82394C21.1089 11.0745 21.1089 16.2889 17.8584 19.5621C14.6755 22.8126 9.43848 22.8126 6.18792 19.5621C2.93736 16.3115 2.93736 11.0745 6.18792 7.82394L12.0119 2V4.91197L7.61004 9.31379C5.17212 11.7066 5.17212 15.6343 7.61004 18.0723C10.0028 20.5102 13.9306 20.5102 16.3685 18.0723C18.8065 15.6795 18.8065 11.7517 16.3685 9.31379Z",
		fill: "#EE4C2C"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.0299 6.37931C16.0299 6.97772 15.5448 7.46284 14.9464 7.46284C14.348 7.46284 13.8629 6.97772 13.8629 6.37931C13.8629 5.7809 14.348 5.29578 14.9464 5.29578C15.5448 5.29578 16.0299 5.7809 16.0299 6.37931Z",
		fill: "#EE4C2C"
	})]
});
export { SvgIconPytorchLogo as ReactComponent };
